import { firstRegularNumbers } from "@Common/helpers/number";

// Types
type CustomizedYTickProps = {
	x?: number;
	y?: number;
	payload?: { value: number };
	unitType: string;
};

export default function CustomizedYTick(props: Readonly<CustomizedYTickProps>) {
	const { x, y, payload, unitType } = props;

	return (
		<g>
			<text
				x={x}
				y={(y ?? 0) - 12}
				dy={16}
				fontFamily="Montserrat"
				fontSize="10px"
				fontWeight={"500"}
				textAnchor="end"
				fill={"#666666"}
				fillOpacity={"0.5"}
			>
				{unitType === "finance" ? `$${firstRegularNumbers(payload?.value)}` : payload?.value}
			</text>
		</g>
	);
}
